import React from 'react';

const Icon = ({ name, className = '', size = 24, ...props }) => {
  return (
    <span 
      className={`material-symbols-outlined ${className}`}
      style={{ fontSize: size }}
      {...props}
    >
      {name}
    </span>
  );
};

export default Icon;

